module.exports = __webpack_public_path__ + "static/media/wi-sunset.d96e94d5.svg";